var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.13 5.636a.38.38 0 0 0-.531 0l-8.535 8.546a.374.374 0 0 0 0 .531l3.202 3.206a.36.36 0 0 0 .523 0l8.542-8.546a.38.38 0 0 0 0-.531zM5.264 15.522a.38.38 0 0 0-.52-.01.36.36 0 0 0-.1.16L3.02 20.48a.37.37 0 0 0 .09.382.37.37 0 0 0 .404.12l4.802-1.603a.39.39 0 0 0 .247-.27.37.37 0 0 0-.105-.374zM20.224 3.756a2.69 2.69 0 0 0-3.74 0l-.531.532a.375.375 0 0 0 0 .532l3.201 3.205a.38.38 0 0 0 .524 0l.546-.524a2.643 2.643 0 0 0 0-3.745"
  })));
};
export default SvgEdit;